// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-btn-section1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  padding: 0 0rem 0 14rem; 

}

.back-button25{
  position: relative;
    background-color: #474559 !important;
    color: #fff !important;
    border: 2px solid white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: large;
    margin-top: 8px;
    left: -96px;
    display: block;
  }

.user-back-btn1 {
  justify-self: start;
  background-color: #474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  text-wrap: nowrap;
  
}

.user-pdf-btn1 {
  justify-self: end;
  background-color: #474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  margin-left: 315px;
  display: block;
}

@media (max-width: 768px) {
  .user-back-btn1 {
      padding-top: 0px !important;
  }

  .user-btn-section1 {
      padding: 0px;
      margin-left: 0px;
      align-items: flex-start;
  }

  .resume-left1 {
      padding: 18px;

  }

  @media (min-width: 768px) and (max-width: 1024px) {
      .user-pdf-btn1 {
          padding-top: 0px !important;
          margin-left: 264px;
      }

      .user-btn-section1 {
          padding: 0px;
          margin-left: 0px;
          align-items: flex-start;
      }
  }

  .resume1 {
      display: inline-block;
      flex-wrap: wrap;
      width: 100%;
      max-width: 800px;
      /* border: 1px solid #ddd; */
      /* border-radius: 8px; */
      overflow: hidden;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }

  .user-resume1 {
      align-items: flex-start !important;
  }
}

.user-scroll-container1 {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
}
.a4-resume{
      width: 210mm;
      height: 297mm;
      padding: 20mm;
      background: #f9f9f9;
      border: 1px solid #ccc;
      box-sizing: border-box;
  }
  

.user-resume1 {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 1000px;
  justify-content: center;
  align-items: flex-end;
  margin: 0;
}

.resume1 {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.resume-left1 {
  /* background-color: rgb(196, 206, 214); */
  color: #ecf0f1;
  justify-content: space-between;
  padding: 20px;
  text-align: left;
}

.user-profile-image1 {
  display: flex;
}

.user-profile-image1 img {
  width: 160px;
  height: 230px;
  /* border-radius: 50%; */
  /* border: 2px solid rgb(126, 155, 189); */
  /* filter: grayscale(80%); */
  margin: 10px auto;
  justify-content: center !important;
  align-items: center !important;
  object-fit: cover;
  display: block;
  position: relative;
  top: -30px;
  left: 20px;
  z-index: 2;
}

.style-div1 {
  width: 160px !important;
  height: 230px !important;
  border: 2px solid black;
  margin: 10px auto;
  justify-content: center !important;
  align-items: center !important;
  object-fit: cover;
  position: relative;
  left: -115px;
  z-index: 1;

}

.name-title-div {
  width: 200px;
  height: 64px;
  background: #fff;
  margin: 10px auto;
  justify-content: center !important;
  align-items: center !important;
  object-fit: cover;
  display: block;
  position: relative;
  left: 120px;
  top: -220px;
  z-index: 2;
}

.user-name1 {
  text-align: center;
  font-size: 1.6em;
  margin-top: 10px;
  font-weight: 500;
  color: black;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.user-job-title1 {
  margin-top: -8px;
  font-size: 18px;
  padding-right: 18px;
  text-align: center;
  font-weight: 300;
  color: black;
  text-transform: capitalize;
}
.user-contact1{
  position: relative;
  left: 250px;
  top: -230px;
  width: 525px;
}
.job-title1::first-letter {
  text-transform: uppercase;
}
.user-contact1 h1 {
  font-weight: 500;
  color: black;
  text-transform: uppercase;
  margin-top: 10px;
}

.user-contact1 li {
  font-weight: 500;
  /* font-size: 16px; */
  color: black !important;
  margin-top: 10px;
 
  margin: -2px;
}

.user-icon1 {
  position: relative;
  top: 5px;
  margin-right: 6px;
}

.line {
  height: 210px;
  width: 2px;
  /* background: #0000006e; */
  position: relative;
  top: -240px;
  left: 50px;
  z-index: 2;
}

.user-objective {
  position: relative;
  width: 550px;
  padding: 20px;
  overflow: hidden;
  left: 170px;
  bottom: 420px;
}

.user-resume-section1 {
  max-width: 100%;
}

.objective-para {
  font-size: 15px;
  font-weight: 500;
  color: #000;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  display: block;
  white-space: normal;
  text-align: justify;
}
.contact-para {
  width: 100%;
  /* font-size: 15px; */
  /* font-weight: 500; */
  color: #000;
  word-wrap: break-word;
  /* overflow-wrap: break-word; */
  max-width: 100%;
  /* display: block; */
  white-space: normal;
  text-align: justify;

}

.objective-title1 {
  width: fit-content;
  color: #000000cf;
  position: relative;
  bottom: 320px;
  left: 24px;
  background-color: #fff;
  z-index: 2;
  text-transform: uppercase;
}

.user-div2 {
  position: relative;
  bottom: 460px;
  left: 33px;
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp2525.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;AAEF;EACE,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;MACI,2BAA2B;EAC/B;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;EAC3B;;EAEA;MACI,aAAa;;EAEjB;;EAEA;MACI;UACI,2BAA2B;UAC3B,kBAAkB;MACtB;;MAEA;UACI,YAAY;UACZ,gBAAgB;UAChB,uBAAuB;MAC3B;EACJ;;EAEA;MACI,qBAAqB;MACrB,eAAe;MACf,WAAW;MACX,gBAAgB;MAChB,4BAA4B;MAC5B,wBAAwB;MACxB,gBAAgB;MAChB,2CAA2C;EAC/C;;EAEA;MACI,kCAAkC;EACtC;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;MACM,YAAY;MACZ,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,sBAAsB;MACtB,sBAAsB;EAC1B;;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,0CAA0C;EAC1C,4BAA4B;EAC5B,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;;AAEZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ","sourcesContent":[".user-btn-section1 {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px;\r\n  padding: 0 0rem 0 14rem; \r\n\r\n}\r\n\r\n.back-button25{\r\n  position: relative;\r\n    background-color: #474559 !important;\r\n    color: #fff !important;\r\n    border: 2px solid white;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: bold;\r\n    font-size: large;\r\n    margin-top: 8px;\r\n    left: -96px;\r\n    display: block;\r\n  }\r\n\r\n.user-back-btn1 {\r\n  justify-self: start;\r\n  background-color: #474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  text-wrap: nowrap;\r\n  \r\n}\r\n\r\n.user-pdf-btn1 {\r\n  justify-self: end;\r\n  background-color: #474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  margin-left: 315px;\r\n  display: block;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .user-back-btn1 {\r\n      padding-top: 0px !important;\r\n  }\r\n\r\n  .user-btn-section1 {\r\n      padding: 0px;\r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n  }\r\n\r\n  .resume-left1 {\r\n      padding: 18px;\r\n\r\n  }\r\n\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n      .user-pdf-btn1 {\r\n          padding-top: 0px !important;\r\n          margin-left: 264px;\r\n      }\r\n\r\n      .user-btn-section1 {\r\n          padding: 0px;\r\n          margin-left: 0px;\r\n          align-items: flex-start;\r\n      }\r\n  }\r\n\r\n  .resume1 {\r\n      display: inline-block;\r\n      flex-wrap: wrap;\r\n      width: 100%;\r\n      max-width: 800px;\r\n      /* border: 1px solid #ddd; */\r\n      /* border-radius: 8px; */\r\n      overflow: hidden;\r\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .user-resume1 {\r\n      align-items: flex-start !important;\r\n  }\r\n}\r\n\r\n.user-scroll-container1 {\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n}\r\n.a4-resume{\r\n      width: 210mm;\r\n      height: 297mm;\r\n      padding: 20mm;\r\n      background: #f9f9f9;\r\n      border: 1px solid #ccc;\r\n      box-sizing: border-box;\r\n  }\r\n  \r\n\r\n.user-resume1 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  width: 1000px;\r\n  justify-content: center;\r\n  align-items: flex-end;\r\n  margin: 0;\r\n}\r\n\r\n.resume1 {\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.resume-left1 {\r\n  /* background-color: rgb(196, 206, 214); */\r\n  color: #ecf0f1;\r\n  justify-content: space-between;\r\n  padding: 20px;\r\n  text-align: left;\r\n}\r\n\r\n.user-profile-image1 {\r\n  display: flex;\r\n}\r\n\r\n.user-profile-image1 img {\r\n  width: 160px;\r\n  height: 230px;\r\n  /* border-radius: 50%; */\r\n  /* border: 2px solid rgb(126, 155, 189); */\r\n  /* filter: grayscale(80%); */\r\n  margin: 10px auto;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  object-fit: cover;\r\n  display: block;\r\n  position: relative;\r\n  top: -30px;\r\n  left: 20px;\r\n  z-index: 2;\r\n}\r\n\r\n.style-div1 {\r\n  width: 160px !important;\r\n  height: 230px !important;\r\n  border: 2px solid black;\r\n  margin: 10px auto;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  object-fit: cover;\r\n  position: relative;\r\n  left: -115px;\r\n  z-index: 1;\r\n\r\n}\r\n\r\n.name-title-div {\r\n  width: 200px;\r\n  height: 64px;\r\n  background: #fff;\r\n  margin: 10px auto;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  object-fit: cover;\r\n  display: block;\r\n  position: relative;\r\n  left: 120px;\r\n  top: -220px;\r\n  z-index: 2;\r\n}\r\n\r\n.user-name1 {\r\n  text-align: center;\r\n  font-size: 1.6em;\r\n  margin-top: 10px;\r\n  font-weight: 500;\r\n  color: black;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.user-job-title1 {\r\n  margin-top: -8px;\r\n  font-size: 18px;\r\n  padding-right: 18px;\r\n  text-align: center;\r\n  font-weight: 300;\r\n  color: black;\r\n  text-transform: capitalize;\r\n}\r\n.user-contact1{\r\n  position: relative;\r\n  left: 250px;\r\n  top: -230px;\r\n  width: 525px;\r\n}\r\n.job-title1::first-letter {\r\n  text-transform: uppercase;\r\n}\r\n.user-contact1 h1 {\r\n  font-weight: 500;\r\n  color: black;\r\n  text-transform: uppercase;\r\n  margin-top: 10px;\r\n}\r\n\r\n.user-contact1 li {\r\n  font-weight: 500;\r\n  /* font-size: 16px; */\r\n  color: black !important;\r\n  margin-top: 10px;\r\n \r\n  margin: -2px;\r\n}\r\n\r\n.user-icon1 {\r\n  position: relative;\r\n  top: 5px;\r\n  margin-right: 6px;\r\n}\r\n\r\n.line {\r\n  height: 210px;\r\n  width: 2px;\r\n  /* background: #0000006e; */\r\n  position: relative;\r\n  top: -240px;\r\n  left: 50px;\r\n  z-index: 2;\r\n}\r\n\r\n.user-objective {\r\n  position: relative;\r\n  width: 550px;\r\n  padding: 20px;\r\n  overflow: hidden;\r\n  left: 170px;\r\n  bottom: 420px;\r\n}\r\n\r\n.user-resume-section1 {\r\n  max-width: 100%;\r\n}\r\n\r\n.objective-para {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #000;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  max-width: 100%;\r\n  display: block;\r\n  white-space: normal;\r\n  text-align: justify;\r\n}\r\n.contact-para {\r\n  width: 100%;\r\n  /* font-size: 15px; */\r\n  /* font-weight: 500; */\r\n  color: #000;\r\n  word-wrap: break-word;\r\n  /* overflow-wrap: break-word; */\r\n  max-width: 100%;\r\n  /* display: block; */\r\n  white-space: normal;\r\n  text-align: justify;\r\n\r\n}\r\n\r\n.objective-title1 {\r\n  width: fit-content;\r\n  color: #000000cf;\r\n  position: relative;\r\n  bottom: 320px;\r\n  left: 24px;\r\n  background-color: #fff;\r\n  z-index: 2;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.user-div2 {\r\n  position: relative;\r\n  bottom: 460px;\r\n  left: 33px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
